import { IFavorite } from 'models/Favorite'
import { IError, IPayload } from 'models/Global'
import { IShift } from 'models/Shift'
import { action, payload } from 'ts-action'

export const PendingReviewShiftsFetching = action(
  'PendingReviewShiftsFetching',
  payload<boolean>(),
)

export const GetPendingReviewShifts = action(
  'GetPendingReviewShifts',
  payload<IPayload<IShift[]>>(),
)

export const GetPendingReviewShiftsWithoutConcat = action(
  'GetPendingReviewShiftsWithoutConcat',
  payload<IPayload<IShift[]>>(),
)

export const GetPendingReviewShiftsErrors = action(
  'GetPendingReviewShiftsErrors',
  payload<IError>(),
)

export const ClearPendingReviewShiftsReducer = action(
  'ClearPendingReviewShiftsReducer',
)

export const PendingReviewShiftsUnfavoriteBusiness = action(
  'PendingReviewShiftsUnfavoriteBusiness',
  payload<number>(),
)

export const PendingReviewShiftsFavoriteBusiness = action(
  'PendingReviewShiftsFavoriteBusiness',
  payload<IFavorite>(),
)

export const PendingReviewShiftsSetHasMore = action(
  'PendingReviewShiftsSetHasMore',
  payload<boolean>(),
)
